<template>
    <div class="container">
        <div class="py-5 text-center">
            <h2>Регистрация</h2>
        </div>

        <div v-if="errors" v-for="error in errors">
            <div class="alert alert-danger" role="alert">{{ error}}</div>
        </div>

        <div class="row">

            <div class="col-md">
                <form class="needs-validation" @submit.prevent="onSubmit
                ">
                    <div class="mb-3">
                        <b-form-checkbox
                            id="residentts"
                            v-model="residents"
                            name="residents"
                            >
                            Форма заполнения для не резидентов РК
                        </b-form-checkbox>
                    </div>

                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label for="name">ФИО</label>
                            <input type="text" class="form-control" id="name" v-model="item.name" required>
                            <div class="invalid-feedback">Обязательно для заполнение</div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="company">Наименование компании</label>
                            <input type="text" class="form-control" id="company" v-model="item.company" required>
                            <div class="invalid-feedback">Обязательно для заполнение</div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="username">Email</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">@</span>
                            </div>
                            <input type="text" class="form-control" id="username" placeholder="Email" v-model="item.email" required>
                            <div class="invalid-feedback">Обязательно для заполнение</div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="legal-address">Юридический адрес</label>
                        <input type="text" class="form-control" id="legal-address" v-model="item.legal_address" placeholder="Юридический адрес">
                        <div class="invalid-feedback">Обязательно для заполнение</div>
                    </div>

                    <div class="mb-3">
                        <label for="iik">ИИК</label>
                        <input type="text" class="form-control" id="iik" placeholder="ИИК" v-model="item.iik" required>
                        <span v-if="!residents" class="little_desc">* ИИК должен содержать "KZ" и 18 знаков</span>
                        <div class="invalid-feedback">Обязательно для заполнение</div>
                    </div>

                    <div class="mb-3">
                        <label for="bik">БИК</label>
                        <input type="text" class="form-control" id="bik" placeholder="БИК" v-model="item.bik" required>
                        <span v-if="!residents" class="little_desc">* БИК должен содержать 8 букв латиницей в верхнем регистре</span>
                        <div class="invalid-feedback">Обязательно для заполнение</div>
                    </div>

                    <div class="mb-3">
                        <label for="bank">Наименование банка</label>
                        <input type="text" class="form-control" id="bank" placeholder="Наименование банка" v-model="item.bank_name" required>
                        <div class="invalid-feedback">Обязательно для заполнение</div>
                    </div>

                    <div class="mb-3">
                        <label for="bin">БИН</label>
                        <input type="text" class="form-control" id="bin" placeholder="БИН" v-model="item.bin" required>
                        <span v-if="!residents" class="little_desc">* БИН должен содержать 12 цифр</span>
                        <div class="invalid-feedback">Обязательно для заполнение</div>
                    </div>

                    <div class="mb-3">
                        <label for="phone">Телефоны</label>
                        <input type="text" class="form-control" id="phone" placeholder="Телефоны" v-model="item.phone" required>
                        <div class="invalid-feedback">Обязательно для заполнение</div>
                    </div>

                    <div class="mb-3">
                        <label for="comment">Примечание (не обязательно)</label>
                        <input type="text" class="form-control" id="comment" placeholder="Примечание" v-model="item.comment">
                    </div>



                    <div class="row">
                        <div class="col-md-6 mb-3">
                            <label for="password">Пароль</label>
                            <input type="password" class="form-control" id="password" v-model="item.password" required>
                            <div class="invalid-feedback">Обязательно для заполнение</div>
                        </div>
                        <div class="col-md-6 mb-3">
                            <label for="password-check">Повторите пароль</label>
                            <input type="password" class="form-control" id="password-check" v-model="item.password_confirmation" required>
                            <div class="invalid-feedback">Обязательно для заполнение</div>
                        </div>
                    </div>



                    <hr class="mb-4">
                    <button class="btn btn-primary btn-lg btn-block btn-yellow" type="submit">Регистрация</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    const swal = require('sweetalert2');
    export default {
        data() {
            return {
                item: {},
                errors: [],
                residents: false,
            }
        },

        methods: {
            checkForm: function (e) {
                e.preventDefault();
                this.errors = [];

                if (!this.item.name) this.errors.push("ФИО обязателен.");
                if (!this.item.company) this.errors.push("Компания обязателен.");

                if (!this.residents) {
                    if (!this.item.bin) this.errors.push("БИН обязателен.");
                    if (!/\d{12}/.test(this.item.bin) || this.item.bin.length > 12) this.errors.push("БИН введен неверно")
                    if (!this.item.bik) this.errors.push("БИК обязателен.");
                    if (!/[A-Z]{8}/.test(this.item.bik) || this.item.bik.length > 8) this.errors.push("БИК введен неверно")
                    if (!this.item.iik) this.errors.push("ИИК обязателен.");
                    if (!/KZ[A-Z0-9_.-]{18}/.test(this.item.iik) || this.item.iik.length > 20) this.errors.push('ИИК введен неверно');
                }

                if (!this.item.bank_name) this.errors.push("Наименование банка обязателен.");
                if (!this.item.legal_address) this.errors.push("Юридический адрес обязателен.");
                if (!this.item.email) this.errors.push("Email обязателен.");
                if (!/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(this.item.email)) this.errors.push("Неверный e-mail");
                if (!this.item.phone) this.errors.push("Номер обязателен.");
                if (!this.item.password) this.errors.push("Пароль обязателен.");
                if (this.item.password && this.item.password.length <= 7) this.errors.push("Минимальная длина пароля 8 символов.");
                if (!/\d/.test(this.item.password)) this.errors.push("Содержать минимум одну цифру.");
                if (!/[A-Z]/.test(this.item.password)) this.errors.push("Содержать минимум 1 заглавную букву.");
                if (this.item.password !== this.item.password_confirmation) this.errors.push("Пароли не совпадают.");
            },

            onSubmit(e) {
                this.checkForm(e)
                if (this.errors.length === 0) {
                    this.item.residents = JSON.parse(this.residents)
                    this.axios
                        .post(this.axios.defaults.baseURL + 'register', this.item)
                        .then(response => {
                            if (response.data.message === 'success') {
                                swal.fire({
                                    icon: 'success',
                                    title: 'Вы успешно зарегистрировались, ждите доступа от менеджера',
                                    showConfirmButton: true,
                                    onClose: () => {
                                        this.$router.push({name: 'login'})
                                    }
                                });
                            } else {
                                this.errors = response.data.errors
                            }
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }else{
                    this.scrollToTop()
                }
            },

            scrollToTop() {
                window.scrollTo(0,0);
            }
        }
    }
</script>

<style scoped lang="scss">

    .container{
        max-width: 768px!important;
        margin: 0 auto 50px;
    }

    .image-cart {
        width: 100%;
        height: 200px;
        object-fit: contain;
        object-position: center;
    }

    .buttons {
        margin: 25px 0;
    }

    .little_desc {
        margin-top: 5px;
        font-size: 12px;
        color: #aaa;
        margin-left: 5px;
    }

    .btn-yellow{
        background-color: #e8d800;
        color: #000;
        box-shadow: none!important;
        border: 0;
    }

    .btn-yellow:hover{
        background-color: #000;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/pages/auth/register.vue